
import {Component, Prop, Watch, On} from 'nuxt-property-decorator';
import ErrorCatcher from '~/components/ErrorCatcher.vue';
import BaseFormComponent from '~/components/Form/BaseFormComponent';
import FormAvatarPicker from '~/components/page-components/FormAvatarPicker.vue';
import SaveOrCancel from '~/components/page-components/SaveOrCancel.vue';
import PrettyContextMenu from '~/components/PrettyContextMenu.vue';
import PhotoPreview from '~/components/misc/PhotoPreview.vue';
import PhotoCropper from '~/components/misc/PhotoCropper.vue';
import AvatarEditable from '~/components/misc/AvatarEditable.vue';
import LoadingContext from '~/components/util/LoadingContext.vue';
import {childService} from '~/lib/accessors/api';
import {childGetSingleStore, childProfileStore} from '~/lib/accessors/store-accessor';
import ChildView from '~/lib/types/ChildView';
import {EditMode} from '~/lib/types/EditMode';
import {emitToRef} from '~/lib/util/util';
import {castToHtmlElement} from '~/lib/util/util';


@Component({
  components: {FormAvatarPicker, SaveOrCancel, ErrorCatcher,
    LoadingContext, PrettyContextMenu, AvatarEditable, PhotoPreview,
    PhotoCropper},
})
export default class ChildAvatarEditable extends BaseFormComponent {
  @Prop({
    type: Object,
    required: true,
  })
  child!: ChildView

  @Prop({
    type: Boolean,
    default: false,
  })
  showEdit!: boolean

  selectedChildPhoto: File | null = null;
  selectedImageUrl: string | null = null;

  // MODE: 'cropper' | 'no_cropper' = 'no_cropper';
  MODE: 'cropper' | 'no_cropper' = 'cropper';

  get accept_ext() {
    return ['jpg', 'jpeg', 'png'];
  }

  /**
   * Called When user picks a file from input[type=file].
   */
  async onInputChange(event: Event) {
    const files = (event.target as HTMLInputElement)!.files!;

    const wrong_ext_msg = `Błędne rozszerzenie pliku. Obsługiwane rozszerzenia to: ${this.accept_ext.join(', ')}`;

    if (!this.doValidate(!!files, 'Nie wybrano pliku')) {
      return this.clearInput();
    }

    if (files.length === 0) {
      return this.clearInput();
    }

    if (! this.doValidate(files.length === 1, 'Należy wybrać tylko jeden plik')) {
      return this.clearInput();
    }

    if (! this.doValidate(['image/jpeg', 'image/png'].includes(files[0].type), wrong_ext_msg)) {
      return this.clearInput();
    }

    const file: File = files[0];
    const fileUrl    = URL.createObjectURL(file);

    this.$emit('selected_image_file', file);
    this.$emit('selected_image_url', fileUrl);

    this.selectedChildPhoto = file;
    this.selectedImageUrl   = fileUrl;

    if(this.MODE === 'no_cropper') {
      await this.submit();
      this.clearInput();
    } else {
      // @ts-ignore: TODO
      this.$refs.photoCropper.$emit('open', fileUrl);
    }
  }

  async onCroppedPhoto({blob, originalPhotoUrl}: CropperPhotoEvent) {
    // originalPhotoUrl
    // @ts-ignore: TODO
    this.$refs.photoCropper.$emit('close');

    const filename = 'child_photo.png';

    this.selectedChildPhoto = new File([blob], filename, {type: blob.type});
    await this.submit();
    this.clearInput();

    this.$emit('after_cropped_photo', {blob, originalPhotoUrl});
  }

  clearInput() {
    const input: HTMLInputElement = castToHtmlElement<HTMLInputElement>(this.$refs.inputFileElem as any)!;
    if(input) {
      input.value = '';
    }
    this.selectedChildPhoto = null;
    this.selectedImageUrl   = null;
  }

  async send() {
    if (!this.doValidate(this.selectedChildPhoto, 'Wybierz zdjęcie podopiecznego z dysku')) return false;

    // @ts-ignore: TODO
    this.$refs.contextMenu!.$emit('close');

    // this.editMode = 'not_editing';
    const childRet = await childService
        .withContext(this, {
          // onBeforeThrowError: () => this.editMode = 'not_editing',
          emitErrorsTo: this.$refs.errorCatcher
        })
        .updatePhoto(this.child.id, this.selectedChildPhoto!);


    childGetSingleStore.setChild(childRet);
    this.selectedChildPhoto = null;

    // Reload user data so that uzupelnij-profil alery is recalculated
    await this.$auth.fetchUser();

    // this.editMode = 'not_editing';
    return true
  }

  mounted() {
    // this.$refs.photoCropper.$emit('open', 'http://thinkpad.tail0a4ec.ts.net/media/profile_gallery/5851/1_q5ja3Gr.jpg');
    // @ts-ignore
    // this.$refs.photoCropper.$emit('open', 'http://thinkpad.tail0a4ec.ts.net/media/profile_gallery/5851/1_C7hoQrM.png');
    // @ts-ignore
    // this.$refs.photoCropper.$emit('open', 'http://thinkpad.tail0a4ec.ts.net/media/profile_gallery/5851/1_C7hoQrM.png');
    // @ts-ignore
    // this.$refs.photoCropper.$emit('open', 'http://thinkpad.tail0a4ec.ts.net/media/profile_gallery/5851/1_QQTTJoa.png');
    this.$on('set_profile_image_from_gallery', async (photo: GalleryPhoto) => {
      (this.$refs.photoCropper as Vue).$emit('open', photo.photo_url);
    });

  }

  @Watch('selectedChildPhoto')
  watchValue(v: File | null): void {
    if(v) {
      // @ts-ignore: TODO
      // this.$refs.photoCropper.$emit('open_preview', this.selectedChildPhoto!);
      // this.submit();
    }
  }

  @Watch('childPhotoUrl')
  watchValueXXX(v: any): void {
    if(v) {
      // @ts-ignore: TODO
      // this.$refs.photoCropper.$emit('open', this.child.photoUrl);
      // this.$refs.photoCropper.$emit('open', v);
    }
  }

  @On('remove_profile_photo')
  async removePhoto() {
    const childRet = await childService
        .withContext(this, {
          emitErrorsTo: this.$refs.errorCatcher
        })
        .deletePhoto(this.child.id);

    // close the preview
    // @ts-ignore: TODO
    this.$refs.photoPreview!.$emit('close_preview');

    childGetSingleStore.setChild(childRet);

    // Reload user data so that uzupelnij-profil alery is recalculated
    await this.$auth.fetchUser();
  }

  confirm(message: string) {
    return confirm(message);
  }

  cancel() {
    // emitToRef(this.$refs.avatarPicker, 'clear')
    // this.editMode      = 'not_editing';
    // this.childPhotoUrl = this.child.photoUrl;
    // this.selectedChildPhoto = null;
    this.clearInput();
  }

  dummy() {
  }

  get profilePhotoInputOpened() {
    return childProfileStore.profilePhotoInputOpened;
  }

  openProfilePhotoInput() {
    childProfileStore.openProfilePhotoInput();
  }

  @Watch('profilePhotoInputOpened')
  onProfilePhotoInputOpenedChange(v: boolean) {
    console.log('ChildAvatarEditable profilePhotoInputOpened ->', v);
    if(v) {
      // @ts-ignore: TODO
      this.$refs.contextMenu!.$emit('close');

      // @ts-ignore: TODO
      // this.$refs.avatarPicker!.$refs.inputFile.click();
      this.$refs.inputFileElem.click();
    }
  }

  get childPhotoUrl(): string {
    // return this.childPhoto ? URL.createObjectURL(this.childPhoto) : this.child.photoThumbUrl;
    return this.child.photoThumbUrl;
  }

  get editMode(): EditMode {
    return this.selectedChildPhoto ? 'editing' : 'not_editing';
  }
}
